import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import styles from './thayanyvianaa.module.scss';
import BackgroundLinks from './src/background-links.png';
import LinkCursos from './src/1.png';
import LinkMentorias from './src/2.png';
import LinkProcedimentos from './src/3.png';
import LinkLocalizacao from './src/4.png';

const MARQUEE_PHRASE = 'THAYANY VIANA • ';
const MARQUEE_TEXT = MARQUEE_PHRASE.repeat(24);
const MARQUEE_COPIES = 4;

const Thayanyvianaa: React.FC = () => {
    const trackRef = useRef<HTMLUListElement>(null);

    useEffect(() => {
        const track = trackRef.current;
        if (!track) return;

        const handleVisibility = () => {
            track.style.animationPlayState = document.hidden ? 'paused' : 'running';
        };

        document.addEventListener('visibilitychange', handleVisibility);
        return () => document.removeEventListener('visibilitychange', handleVisibility);
    }, []);

    return (
        <div className={styles.thayanyvianaa}>
            <div className={styles.main}>
                <img
                    className={styles.cardImage}
                    src={BackgroundLinks}
                    alt="Thayany Viana — cartão digital"
                    decoding="async"
                />

                <div className={styles.marqueeContainer} aria-hidden>
                    <section className={styles.marqueeSection}>
                        <ul className={styles.marqueeTrack} ref={trackRef}>
                            {Array.from({ length: MARQUEE_COPIES }, (_, index) => (
                                <li
                                    key={index}
                                    className={styles.marqueeSlide}
                                    aria-hidden={index > 0}
                                >
                                    <div className={styles.marqueeItem}>
                                        <p className={styles.marqueeText}>{MARQUEE_TEXT}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </section>
                </div>
                <div className={styles.content}>
                    <a href="https://wa.me/5517981302893?text=Olá, tudo bem? Vim pelo Instagram e gostaria de informações sobre o curso de sobrancelha..." className={styles.contentLink}>
                        <img
                            className={styles.contentImage}
                            src={LinkCursos}
                            alt="Cursos — clique para saber mais"
                            decoding="async"
                        />
                    </a>
                    <a href="https://wa.me/5517981302893?text=Olá, tudo bem? Vim pelo Instagram e gostaria de informações sobre a mentoria on-line rebrows..." className={styles.contentLink}>
                        <img
                            className={styles.contentImage}
                            src={LinkMentorias}
                            alt="Mentorias online Rebrows — clique para saber mais"
                            decoding="async"
                        />
                    </a>
                    <Link to="/thayanyvianaa/procedimentos" className={styles.contentLink}>
                        <img
                            className={styles.contentImage}
                            src={LinkProcedimentos}
                            alt="Procedimentos — clique para saber mais"
                            decoding="async"
                        />
                    </Link>
                    <a href="https://maps.app.goo.gl/UN2u1NyTXGriGjoh6" className={styles.contentLink}>
                        <img
                            className={styles.contentImage}
                            src={LinkLocalizacao}
                            alt="Localização — clique para saber mais"
                            decoding="async"
                        />
                    </a>
                </div>

            </div>
        </div>
    );
};

export default Thayanyvianaa;
